/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const UPDATE_GIFT_MESSAGE = 'UPDATE_GIFT_MESSAGE';
export const GIFT_MESSAGE_UPDATED_SUCCESSFULLY = 'GIFT_MESSAGE_UPDATED_SUCCESSFULLY';
export const TRIGGER_ADD_GIFT_MESSAGE = 'three-step-checkout/POST/ADD_GIFT_MESSAGE';
export const HANDLE_GIFT_MESSAGE_CHANGE = 'three-step-checkout/HANDLE_GIFT_MESSAGE_CHANGE';
export const LOAD_GIFT_MESSAGE_CHANGE = 'three-step-checkout/LOAD_GIFT_MESSAGE_CHANGE';
export const HANDLE_AUTHOR_CHANGE = 'three-step-checkout/HANDLE_AUTHOR_CHANGE';
export const TRIGGER_CHANGE_GIFT_MESSAGE = 'three-step-checkout/TRIGGER_CHANGE_GIFT_MESSAGE';
export const UPDATE_FORM_STATUS = 'three-step-checkout/UPDATE_FORM_STATUS';
export const UPDATE_OCCASSION = 'three-step-checkout/UPDATE_OCCASSION';
export const UPDATE_OCCASION_NAME = 'three-step-checkout/UPDATE_OCCASION_NAME';
export const SHOW_GIFT_MESSAGE_FORM = 'three-step-checkout/SHOW_GIFT_MESSAGE_FORM';
export const TRIGGER_SKIP_MESSAGE = 'three-step-checkout/TRIGGER_SKIP_MESSAGE';
export const TRIGGER_RESET_MESSAGE = 'three-step-checkout/TRIGGER_RESET_MESSAGE';
export const TRIGGER_GCI_PERSONALIZATION_COMPLETE = 'three-step-checkout/TRIGGER_GCI_PERSONALIZATION_COMPLETE';
export const GCI_PERSONALIZATION_UPDATE_STATUS = 'GCI_PERSONALIZATION_UPDATE_STATUS';
export const ENTERPRISE_ADD_GIFT_MESSAGE = 'mbp-checkout/ENTERPRISE_ADD_GIFT_MESSAGE';
export const UPDATE_PRODUCT_PERSONALIZATION_COMPLETE = 'mbp-checkout/MFE/UPDATE_PRODUCT_PERSONALIZATION_COMPLETE';
